import React from 'react';
import {observer} from 'mobx-react';
import {Modal} from 'shared/components/modals';
import {Avatar} from 'shared/components';
import {InteractiveContext, Pagination} from 'main/components';
import {calendarDate} from 'shared/tools';
import {endpoints, types} from 'main/tools';
import {SurveyAnswer} from 'main/stores/surveys';

const Answers = observer(({models}) => {
  return (
    <React.Fragment>
      {models.map(({employee, submittedAt}, index) =>
        <div className='flex mb2' key={index}>
          <div className='mr2'>
            <Avatar employee={employee} size='sm' className='left'/>
          </div>
          <div className='flex jumbo align-items-center'>
            {`${employee.name} · ${calendarDate(submittedAt)}`}
          </div>
        </div>
      )}
    </React.Fragment>
  );
});

const ReviewersModal = observer(({uiState}) => {
  const {questionId, contentFilter, periodDateFilter, reviewersModalOpen} = uiState;
  if (!reviewersModalOpen) return null;

  return (
    <Modal
      size='sm'
      title={contentFilter}
      translateTitle={false}
      isOpen={uiState.reviewersModalOpen}
      onHide={() => uiState.closeReviewersModal()}>
      <InteractiveContext
        proxy={{
          type: 'async',
          endpoint: endpoints.SURVEYS.ANSWERS.WITHOUT_PAGINATION.with(
            {
              questionId, contentFilter, periodDateFilter
            }
          ),
          modelType: types.SURVEYS.ANSWER,
          model: SurveyAnswer,
          pageSize: 25
        }}
      >
        <Answers/>
        <Pagination/>
      </InteractiveContext>
    </Modal>
  );
});

export default ReviewersModal;
